export default function SnowballFightIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="2" y="2" width="60" height="60" rx="14" fill="#BFE3FF" />
      <path d="M2 40 Q 20 32 34 40 T 62 38 V 62 H 2 Z" fill="#F7FBFF" />
      <rect x="6" y="34" width="10" height="10" fill="#F2F8FF" stroke="#9DB8D6" strokeWidth="1.5" />
      <rect x="16" y="34" width="10" height="10" fill="#F2F8FF" stroke="#9DB8D6" strokeWidth="1.5" />
      <rect x="11" y="24" width="10" height="10" fill="#F2F8FF" stroke="#9DB8D6" strokeWidth="1.5" />
      <g transform="translate(44 40)">
        <circle r="10" fill="#FF8A1F" />
        <circle cx="0" cy="-9" r="7" fill="#FFD9B3" />
        <path d="M-7 -11 A7 7 0 0 1 7 -11 Z" fill="#8A4410" />
        <circle cx="0" cy="-19" r="3" fill="#FFFFFF" />
        <path d="M-6 -3 H6" stroke="#2FBF71" strokeWidth="3" />
      </g>
      <circle cx="30" cy="18" r="7" fill="#FFFFFF" stroke="#9DB8D6" strokeWidth="2" />
      <path d="M38 22 L46 26 M37 15 L45 13" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" />
      <path d="M10 10 l2 4 M12 10 l-2 4 M9 12 h4" stroke="#FFFFFF" strokeWidth="1.5" />
    </svg>
  );
}
